import { jsx as i } from "react/jsx-runtime";
function n({ label: r, className: e = "", ...t }) {
  return /* @__PURE__ */ i(
    "button",
    {
      className: `
      p-2 
      rounded-xl 
      bg-interactiveLayerPrimary 
      text-interactiveTextPrimary 
      font-primary 
      hover:bg-interactiveLayerHoverPrimary 
      hover:text-interactiveTextHoverPrimary
      ${e}`,
      ...t,
      children: r
    }
  );
}
export {
  n as Button
};
